import React from "react";
import { ProcessTreeItem } from "../../../../../@types";

const BehaviorContext = React.createContext<
  | {
      active: ProcessTreeItem | undefined;
      setActive: (item: ProcessTreeItem | undefined) => void;
    }
  | undefined
>(undefined);

export { BehaviorContext };
